import React from 'react';
import { getPermissionsForModule, Scopes } from 'src/app/scopes/scopes';

import Dashboard from './Children/Dashboard';
import Terminals from './Children/Terminals';
import Create from './Children/Create';
import Update from './Children/Update';
import Info from './Children/Info';

export const KiosksConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      id: 'kiosksGroup',
      path: 'kiosks',
      scopes: getPermissionsForModule('Kiosk'),
      children: [
        {
          scopes: [Scopes.Kiosk.show],
          id: 'kiosksGroup.dashboard',
          path: 'dashboard',
          element: <Dashboard />,
        },
        {
          scopes: [Scopes.Kiosk.show],
          id: 'kiosksGroup.terminals',
          path: '',
          element: <Terminals />,
        },
        {
          scopes: [Scopes.Kiosk.store],
          id: 'kiosksGroup.create',
          path: 'create',
          element: <Create />,
        },
        {
          scopes: [Scopes.Kiosk.update],
          id: 'kiosksGroup.update',
          path: 'update',
          element: <Update />,
        },
        {
          scopes: [Scopes.Kiosk.show],
          id: 'kiosksGroup.info',
          path: 'info',
          element: <Info />,
        },
      ],
    },
  ],
};
